import {
  PageResponse,
  PageData,
  Response,
  TMSCustomerSearchParams,
  TMSCustomerVo,
  TMSNewCustomerDo,
} from "@/types";
import { APIRequest } from "@/utils/api";

const CustomerAPI = new APIRequest({
  baseURL: "/api/wms/v2/tms/customers",
});

export async function queryCustomers(
  params: TMSCustomerSearchParams,
): Promise<PageData<TMSCustomerVo>> {
  return CustomerAPI.get<PageResponse<TMSCustomerVo>>({
    url: "",
    params,
  }).then((res) => res.data);
}

export async function createCustomer(
  data: TMSNewCustomerDo,
): Promise<TMSCustomerVo> {
  return CustomerAPI.post<Response<TMSCustomerVo>>({
    url: "",
    data,
  }).then((res) => res.data);
}
